import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";

export default function AttendeesPaymentMethodDialog({
  open,
  onClose,
  onSelectPaymentMethod,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
      <div className="fixed inset-0 flex items-center justify-center">
        <DialogPanel className="w-96 border bg-white rounded-lg p-8">
          <DialogTitle className="text-xl font-semibold text-center">
            Select Payment Method
          </DialogTitle>
          <div className="flex flex-col items-center mt-4 space-y-4">
            <button
              className="w-full py-2 border border-black rounded hover:bg-gray-100"
              onClick={() => onSelectPaymentMethod("cash")}
            >
              Paying with Cash
            </button>
            <button
              className="w-full py-2 border border-black rounded hover:bg-gray-100"
              onClick={() => onSelectPaymentMethod("credit")}
            >
              Paying with Credit
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
